import { render, staticRenderFns } from "./AuthForgotNotify.vue?vue&type=template&id=2b5fb0a5&"
import script from "./AuthForgotNotify.vue?vue&type=script&lang=js&"
export * from "./AuthForgotNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b5fb0a5')) {
      api.createRecord('2b5fb0a5', component.options)
    } else {
      api.reload('2b5fb0a5', component.options)
    }
    module.hot.accept("./AuthForgotNotify.vue?vue&type=template&id=2b5fb0a5&", function () {
      api.rerender('2b5fb0a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth/src/features/auth/screens/AuthForgotNotify.vue"
export default component.exports